<script setup lang="ts">
interface SectionTitleSeparatorProps {
    title: string;
}

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const props = defineProps<SectionTitleSeparatorProps>();
</script>

<template>
    <div class="section-title-separator">
        <div class="section-title">{{ title }}</div>
        <div class="separator"></div>
    </div>
</template>

<style scoped lang="scss">
.section-title-separator {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-top: 8px;
    .section-title {
        font-weight: 500;
        color: $text-main-900;
        @include font-size-14;
    }
    .separator {
        flex: 1 0 0;
        height: 1px;
        background-color: $bg-soft-200;
    }
}
</style>
